// Convert jQuery code to vanilla JavaScript
document.addEventListener('DOMContentLoaded', function() {
  // Bootstrap Carousel initialization
  const carousels = document.querySelectorAll('.carousel');
  carousels.forEach(function(carousel) {
    new bootstrap.Carousel(carousel);
  });

  // Call normalizeSlideHeights on window load, resize, and orientation change
  window.addEventListener('load', normalizeSlideHeights);
  window.addEventListener('resize', normalizeSlideHeights);
  window.addEventListener('orientationchange', normalizeSlideHeights);

  function normalizeSlideHeights() {
    const carousels = document.querySelectorAll('.carousel');
    carousels.forEach(function(carousel) {
      const items = carousel.querySelectorAll('.carousel-item');
      
      // Reset the height
      items.forEach(function(item) {
        item.style.minHeight = '0';
      });
      
      // Calculate max height
      let maxHeight = 0;
      items.forEach(function(item) {
        const height = item.offsetHeight;
        if (height > maxHeight) {
          maxHeight = height;
        }
      });
      
      // Set the height
      items.forEach(function(item) {
        item.style.minHeight = maxHeight + 'px';
      });
    });
  }
});

